var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "none",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 10v5.5h-2.2v-3.3H12.2v17.6h11V32H10V10h19zm-1.4 7.7c2.42 0 4.4 1.98 4.4 4.4 0 1.65-.88 3.08-2.2 3.85V32l-2.2-2.2-2.2 2.2v-6.05c-1.32-.77-2.2-2.2-2.2-3.85 0-2.42 1.98-4.4 4.4-4.4zm0 2.2c-1.21 0-2.2.99-2.2 2.2 0 1.21.99 2.2 2.2 2.2 1.21 0 2.2-.99 2.2-2.2 0-1.21-.99-2.2-2.2-2.2zm-7.7-1.1V21h-5.5v-2.2h5.5zm3.4-4.4v2.2h-8.9v-2.2h8.9z",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 6,
    r: 4,
    fill: "none",
    stroke: "none",
    transform: "translate(5 5)",
    fillOpacity: 0,
    strokeOpacity: 0
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iOCIgc3Ryb2tlPSJub25lIiBmaWxsPSJub25lIiBmaWxsLW9wYWNpdHk9IjAiIHN0cm9rZS1vcGFjaXR5PSIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIi8+CiAgICAgICAgPHBhdGggZD0iTTI5IDEwdjUuNWgtMi4ydi0zLjNIMTIuMnYxNy42aDExVjMySDEwVjEwaDE5em0tMS40IDcuN2MyLjQyIDAgNC40IDEuOTggNC40IDQuNCAwIDEuNjUtLjg4IDMuMDgtMi4yIDMuODVWMzJsLTIuMi0yLjItMi4yIDIuMnYtNi4wNWMtMS4zMi0uNzctMi4yLTIuMi0yLjItMy44NSAwLTIuNDIgMS45OC00LjQgNC40LTQuNHptMCAyLjJjLTEuMjEgMC0yLjIuOTktMi4yIDIuMiAwIDEuMjEuOTkgMi4yIDIuMiAyLjIgMS4yMSAwIDIuMi0uOTkgMi4yLTIuMiAwLTEuMjEtLjk5LTIuMi0yLjItMi4yem0tNy43LTEuMVYyMWgtNS41di0yLjJoNS41em0zLjQtNC40djIuMmgtOC45di0yLjJoOC45eiIgZmlsbC1vcGFjaXR5PSIuNiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUgNSkiIGZpbGwtb3BhY2l0eT0iMCIgc3Ryb2tlPSIjRkZGIiBzdHJva2Utb3BhY2l0eT0iMCI+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjI3IiBjeT0iNiIgcj0iNCIgc3Ryb2tlPSJub25lIiBmaWxsPSJub25lIi8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgContractGrey as ReactComponent };